/*global chrome*/

import FingerprintJS from '@fingerprintjs/fingerprintjs';
import LocalStorage from './localstorage';

export const FingerPrintHash = async () => {
    let fingerprint = '';
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const { screenFrame, hdr, screenResolution, colorDepth, availableScreenResolution, pixelRatio, colorGamut, ...components } =
        result.components;
    const visitorId = FingerprintJS.hashComponents(components);
    if (visitorId) {
        fingerprint = visitorId;
    }
    return fingerprint;
};

export const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
};

export const isValidEmail = (value) => {
    const emailRegex =
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return emailRegex.test(value);
};

export const signOut = () => {
    LocalStorage.remove(['diologExtAuthToken', 'userExtData', 'selectedExtCompany', 'isNotFromOrganization']);
    window.location.reload();
};

export const capitalizeFirstLetter = (string) => {
    if (string.length === 0) {
        return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
};
